export const Divider = () => {
  return (
    <div className='flex flex-row gap-2 w-full items-center'>
      <div className='bg-[#E9EAEB] flex-grow h-0.5' />
    </div>
  );
};
